module.exports = __webpack_public_path__ + "img/rightside_300.0cdb802b.png";